// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__19Fd2","label":"Radio_label__3hcH_","checkMark":"Radio_checkMark__3msgz","disabled":"Radio_disabled__um4bh"};